import { DataBean } from "../DataBean";

export class EmployeeDecoration extends DataBean {


    public async getEmployeeDecorationCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("TalentERP", "java.util.List_getEmployeeDecorationCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }
    public async getEmployeeDecorationCatalogByPropertiesRender(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("CacheOptions", "java.util.List_getEmployeeDecorationCatalogByPropertiesRender_java.util.Map_Number", [properties,maxRows]);
    }
    
    
 
}